import React from 'react';
import TutoCreateClasse from '../../../views/AddClasseAndLycee';
import { ContainerFullWidth } from '../../layouts/ContainerFullWidth';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router';
import useGoToPage from '../../../hooks/useGoToPage';
import pages from '../../../routes/pages';
import { HeaderText } from '../../atoms/Texts/HeaderText';
import emoji from '../../../theme/emoji';
import useStyle from './classeChoice.style';
import { ClasseChoiceButton } from '../../atoms/Buttons/ClasseChoiceButton/ClasseChoiceButton';
import { CreateNewClasseButton } from '../../atoms/Buttons/CreateNewClasseButton/CreateNewClasseButton';
import { IconButton } from '../../atoms/Buttons/IconButton';
import logout from '../../../graphql/logout';
import { useMutation, useQuery } from '@apollo/client';
import { GET_USER_CLASSES } from '../../../graphql/query/user/queryUserClasses';
import { MY_ID } from '../../../helpers/user/authorization';
import { LoadingLayout } from '../../molecules/Loaders/LoadingLayout';
import { getUserClassesFromQuery } from '../../../helpers/transformApiResponse/user';
import {
  UpdateUserOptionsMutation,
  UpdateUserOptionsMutationVariables
} from '../../../graphql/generated/graphql';
import { UPDATE_OPTIONS } from '../../../graphql/mutation/options/updateOptions';
import { ID } from '../../../types/typeDef';
import { BackButton } from 'components/molecules/Buttons/BackButton';
import {
  getUserClasse,
  getIfIsPairTeacher
} from 'store/selectors/user/user.selectors';
import { useDispatch } from 'react-redux';
import { closeClasseChoice } from 'store/actions/ui.actions';

export const ClasseChoice = () => {
  const userClasse = useSelector(getUserClasse);
  const userIsPairTeacher = useSelector(getIfIsPairTeacher);
  const dispatch = useDispatch();
  const style = useStyle();
  const goToCreateClassePage = useGoToPage(pages.CREATE_CLASSE_PAGE.path);
  const { data, loading, error } = useQuery(GET_USER_CLASSES, {
    variables: {
      id: MY_ID
    }
  });
  const [saveCurrentClasseToUserOptions] = useMutation<
    UpdateUserOptionsMutation,
    UpdateUserOptionsMutationVariables
  >(UPDATE_OPTIONS, {
    onCompleted: () =>
      setTimeout(() => window.location.assign(pages.HOME_PAGE.path), 10),
    onError: err => console.error(err)
  });
  if (loading) return <LoadingLayout />;
  if (error) return <p>Error</p>;

  const saveCurrentClasseOnUser = (id: ID) => {
    saveCurrentClasseToUserOptions({
      variables: {
        key: 'classeId',
        data: id
      }
    });
  };

  const classes = getUserClassesFromQuery(
    data?.usersPermissionsUser?.data?.attributes?.classes?.data
  );

  if (!classes.length) return <TutoCreateClasse />;
  return (
    <ContainerFullWidth>
      <Switch>
        <Route exact path="/">
          <ContainerFullWidth>
            <div className={style.topBar}>
              <IconButton onClick={logout} icon={'Logout'} />
            </div>
            <div className={style.container}>
              <HeaderText
                text={'Choisir votre classe'}
                emoji={emoji['GradutationCap']}
              />
              {userClasse && (
                <BackButton
                  text="Retourner sur mon espace"
                  onClick={() => dispatch(closeClasseChoice)}
                />
              )}
              <div className={style.buttonsContainer}>
                <div className={style.buttonsColor}>
                  {classes.map(classe => (
                    <ClasseChoiceButton
                      onClick={saveCurrentClasseOnUser}
                      id={classe.id}
                      name={classe.name}
                      lycee={classe.lycee}
                      filiere={classe.filiere}
                      key={classe.id}
                    />
                  ))}
                </div>
                {!userIsPairTeacher && (
                  <CreateNewClasseButton onClick={goToCreateClassePage} />
                )}
              </div>
            </div>
          </ContainerFullWidth>
        </Route>
        <Route
          path={pages.CREATE_CLASSE_PAGE.path}
          component={TutoCreateClasse}
        />
      </Switch>
    </ContainerFullWidth>
  );
};
